<template>
    <div class="modal fade hide" data-backdrop="static" data-keyboard="false" id="approve_modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="row px-4 justify-content-end">
                        <button type="button" @click="hideModal" class="btn btn-sm btn-circle btn-icon bg-white">
                            <i class="fa fa-times "></i>
                        </button>
                    </div>
                    <div class="mb-3">
                    <label for=""> روش برگشت وجه تراکنش</label>
                    <select name="" v-model="selected_refund_method" id="select" class="form-control">
                        <option
                            v-for="(item, index) in getTypes()"
                            :key="index"
                            :value="item.value"
                            v-text="item.title">
                        </option>
                    </select>
                </div>

                    <div class="mb-3" v-if="selected_refund_method === 'wallet_method'">
                        <label for="">انتخاب کیف</label>
                        <select name="" v-model="wallet_hashid" id="select" class="form-control">
                            <option
                                v-for="(item, index) in getWallets()"
                                :key="index"
                                :value="item.id">
                                <span>{{ item.title }}</span>
                                <span> / </span>
                                <span>{{ item.id }}</span>
                                <span> / </span>
                                <span>موجودی: </span>
                                <span>{{ item.available_amount }}</span>
                            </option>
                        </select>
                    </div>

                    <div class="refund-options" v-if="selected_refund_method">
                        <label>انتخاب نوع برگشت:</label>
                        <div>
                            <input
                                type="radio"
                                id="full-amount"
                                name="refund-type"
                                value="full"
                                v-model="refund_type">
                            <label for="full-amount">کل مبلغ تراکنش </label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="partial-amount"
                                name="refund-type"
                                value="partial"
                                v-model="refund_type">
                            <label for="partial-amount">مبلغ دلخواه </label>
                        </div>
                    </div>

                    <div class="partial-amount-input" v-show="refund_type === 'partial'">

                        <input
                            type="number"
                            id="amount"
                            v-model="partial_amount"
                            placeholder="مبلغ را وارد کنید"
                            class="form-control"
                        >
                    </div>

                    <div class="d-flex px-1 justify-content-end mb-3">
                        <button @click="hideModal()"
                                class="btn btn-danger btn-sm px-5 rounded-pill py-2 ml-2 font-weight-bold"
                                style="font-size: 14px">انصراف
                        </button>
                        <button @click="sendRequest" id="approve_button"
                                class="btn btn-primary btn-sm rounded-pill px-5 py-2 mr-2  font-weight-bold"
                                style="font-size: 14px">
                            <span>ارسال</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import Vue from 'vue';
import { transactionService } from '@/common/api.service';
import { KTApp } from '@/plugins/core/app';
import { walletStatus } from '@/constants/walletStatus';

export default Vue.extend( {
    name: "Approve",
    data() {
        return {
            wallet_hashid: null,
            refund_type: 'full',
            partial_amount: null,
            selected_refund_method : null,
            refund_method_types : [],
        }
    },
    computed: {
        walletStatus() {
            return walletStatus
        }

    },
    props: {
        refund_methods: {
            type: Object | Array,
            required: true,
            default: () => ({}),
        },
        transaction_hashid: {
            type: String,
            required: true,
            default: () => (''),
        },
        get_data: {
            type: Function,
            required: true,
            default: () => (''),
        },
    },
    methods: {
        getTypes(){
            let types = [];
            if (!this.refund_methods) {
                return types;
            }
            if (this.refund_methods.wallet_method) {
                types.push({
                    value: 'wallet_method',
                    title: 'از طریق کیف پول'
                })
            }

            return types;
        },
        getWallets() {
            if (this.refund_methods.wallet_method) {
                return this.refund_methods.wallet_method;
            }
        },
        hideModal() {
            $('#approve_modal').modal('hide');
        },
        openModal() {
            $('#approve_modal').modal('show');
            console.log(this.wallet_list);
        },
        sendRequest() {
            if (!this.selected_refund_method ){
                this.toastr.error('روش برگشت وجه تراکنش را انتخاب کنید.');
                return;
            }
            if (this.selected_refund_method === 'wallet_method' && !this.wallet_hashid) {
                this.toastr.error('کیف پول را انتخاب کنید.');
                return;
            }
            if (this.refund_type === 'partial' && (!this.partial_amount || this.partial_amount <= 0)) {
                this.toastr.error('مقدار مبلغ را وارد کنید.');
                return;
            }
            let btn = $('#approve_button');
            KTApp.progress(btn)

            let param = {
                refund_method : 1,
                transaction_id: this.transaction_hashid,
                refund_amount: this.refund_type === 'partial' ? this.partial_amount : null,
            };

            if (this.selected_refund_method === 'wallet_method'){
                param.wallet_id = this.wallet_hashid
            }

            transactionService.reverseTransaction(param)
                .then(({data})=> {
                    this.get_data();
                    this.toastr.success(data.message)
                    this.hideModal();
                }).catch(({response})=> {
                this.toastr.error(response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })

        },
    },
})
</script>
<style scoped>
    a {
        color: #0f9af0 !important;
        cursor: pointer;
    }

    a:hover{
        border-bottom: 1px solid #0f9af0;
    }
    .refund-options {
        margin-bottom: 15px;
    }

    .refund-options div {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
    }

    .refund-options input[type="radio"] {
        margin-right: 8px;
    }

    .partial-amount-input {
        margin-top: 15px;
    }

    input[type="number"] {
        padding: 5px;
        width: 100%;
        box-sizing: border-box;
    }
</style>